import {Injectable} from '@angular/core';
import {AppConfigService} from '../common/service/mpvAppConfigService';
import {HttpApiService} from '../common/service/mpvHttpApiService';
import {SigedCommonService} from '../siged-common.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, pipe} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {AuthService} from './auth.service';
import {DescargarArchivo} from "./download.service";

@Injectable({
  providedIn: 'root'
})

export class ArchivoCentralService {

  private defaultHeaders;
  getListArea: any;
  baseUrl2 = this.mpvCommonService.APPLICATION_API_HOST + '/';

  constructor(
    public httpApiService: HttpApiService,
    public appConfigService: AppConfigService,
    public mpvCommonService: SigedCommonService,
    private http: HttpClient,
    private authService: AuthService,
  ) {
    this.defaultHeaders = {
      Authorization: 'Bearer ' + this.authService.getUser()
    }
  }

  baseUrl = this.mpvCommonService.APPLICATION_API_HOST + '/archivoDocumental/';


  //-----------------------------BUSCAR CAMPOS CAMPOS-----------------------------------------------/
    getArchivosMigradosByPaginationList(
        body: {
            page: string, size: string, nombreArchivo: any,
            criterio: any, anio?: string,
            nivel1?: string,
            nivel2?: string,
            nivel3?: string,
            nivel4?: string,
            nivel5?:string,
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {headers: {...this.defaultHeaders, ...headers}}
        return this.http.post(`${this.baseUrl2}migracionArchivo/listaArchivosMigrados`, body, options).toPromise() }
    getArchivoslistaNivel1(
        body: {
          criterio: any
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {headers: {...this.defaultHeaders, ...headers}}
        return this.http.post(`${this.baseUrl2}migracionArchivo/listaNivel1`, body, options).toPromise() }
    getArchivoslistaNivel2(
        body: {
          nivel1: string,
          criterio: any,
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {headers: {...this.defaultHeaders, ...headers}}
        return this.http.post(`${this.baseUrl2}migracionArchivo/listaNivel2`, body, options).toPromise() }
    getArchivoslistaNivel3(
        body: {
          nivel1: string,
          nivel2: string,
          criterio: any,
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {headers: {...this.defaultHeaders, ...headers}}
        return this.http.post(`${this.baseUrl2}migracionArchivo/listaNivel3`, body, options).toPromise() }
    getArchivoslistaNivel4(
        body: {
          nivel1: string,
          nivel2: string,
          nivel3: string,
          criterio: any,
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {headers: {...this.defaultHeaders, ...headers}}
        return this.http.post(`${this.baseUrl2}migracionArchivo/listaNivel4`, body, options).toPromise() }
    getArchivoslistaNivel5(
        body: {
          nivel1: string,
          nivel2: string,
          nivel3: string,
          nivel4: string,
          criterio: any,
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {headers: {...this.defaultHeaders, ...headers}}
        return this.http.post(`${this.baseUrl2}migracionArchivo/listaNivel5`, body, options).toPromise() }
    getProcesosByPaginationList(
        body: {
            page: string,
            size: string,
            nombreArchivo?: string,
            rutaArchivo?: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const options = {headers: {...this.defaultHeaders, ...headers}}
        return this.http.post(`${this.baseUrl2}migracionArchivo/listaProcesos`, body, options).toPromise() }
    saveProcesoCargaFile(
        body,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
      const options = {headers: {...this.defaultHeaders, ...headers}}
      return this.http.post(`${this.baseUrl2}migracionArchivo/guardarProcesoCargaFile`, body, options).toPromise() }
    saveProcesoCargaArchivo(
        body: {
            nombreArchivo: string,
            rutaArchivo: string,
            pesoArchivo: string
        },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
      const options = {headers: {...this.defaultHeaders, ...headers}}
      return this.http.post(`${this.baseUrl2}migracionArchivo/guardarProcesoCargaArchivo`, body, options).toPromise() }
    initProceso(
        body,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
      const options = {headers: {...this.defaultHeaders, ...headers}}
      return this.http.post(`${this.baseUrl2}migracionArchivo/iniciarProceso`, body, options).toPromise() }
    getArchivosListaZip() {
      const options = { headers: { ... this.authService.getDefualtHeaders() } };
      return this.http.get(`${this.baseUrl2}migracionArchivo/listaArchivosZip`, options).toPromise();
    }
    getDocumentalArchiveByPaginationList(
    body: {
      page: string, size: string, idArea: any,
      idResponsable: any, numeroArchivo: string,
      estado: number[], fechaInico: string, fechaFin: string
    },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}listarArchivoDocumental`, body, options)
      .pipe(map((result: any) => {
        return {
          ...result, list: result.list.map(d => {
              return {
                id: d.idArchivoDocumental,
                area: d.nombreArea,
                responsible: d.responsable,
                numero: d.numeroDocumental,
                date: d.fechaCreacion,
                state: d.estado
              }
            }
          )
        }
      })).toPromise();
  }

  getDeletedDocumentalArchiveByPaginationList(
    body: {
      page: string, size: string, idArea: any,
      idResponsable: any, numeroArchivo: string,
      estado: number[], fechaInico: string, fechaFin: string
    },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}listarArchivoDocumentalEliminado`, body, options)
      .pipe(map((result: any) => {
        return {
          ...result, list: result.list.map(d => {
              return {
                id: d.idArchivoDocumental,
                area: d.nombreArea,
                serie: d.nombreSerie,
                responsible: d.responsable,
                numero: d.numeroArchivo,
                creationDate: d.fechaRegistro,
                endDate: d.fechaVencimiento,
                support: d.tipoSoporte,
                state: d.estado,
                total: d.total
              }
            }
          )
        }
      })).toPromise();
  }


  saveDocumentalArchive(
    body: {
      idArchivoDocumental: any
      idTipoArchivo: any
      idPersona: any
      idPersonaEspecialista: any
      esSerieCerrada: number
      idSerieDocumental: any
      nombreSerieDocumental: string
      codigoSerieDocumental: string
      documentos: {
        idDocumentoArchivo: any, numeroCaja: number,
        numeroPaquete: string, carpeta: any,
        tipoDocumental: string, rangoDocumento: string,
        anio: string, folios: number, descripcion: string,
        observacion: string, esReporteAnulado: number
      }[]
    },
    headers?
  ) {
    const obj = body
    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}crearArchivoDocumental`, obj, options).toPromise();
  }

  prepareDocumentalArchive(
    body: {
      idArchivoDocumental: any
      idTipoArchivo: any
      idPersona: any
      idPersonaEspecialista: any
      esSerieCerrada: number
      idSerieDocumental: any
      nombreSerieDocumental: string
      codigoSerieDocumental: string,
      idOrigen: number,
      documentos: {
        idDocumentoArchivo: any, numeroCaja: number,
        numeroPaquete: string, carpeta: any,
        tipoDocumental: string, rangoDocumento: string,
        anio: string, folios: number, descripcion: string,
        observacion: string, esReporteAnulado: number
      }[]
    },
    headers?
  ) {
    const obj = body
    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}guardarArchivoDocumental`, obj, options).toPromise();
  }

  actualizarArchivoTransferencia(
    body: {
      idArchivoTransferencia?: number,
      nombreArchivo: string,
      uuid: string,
    },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}actualizarArchivoTransferencia`, body, options).toPromise();
  }

  deleteFileByDocument(
    params: HttpParams | { idArchivo: string },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}}
    return this.http.get(`${this.baseUrl}deleteFileOfDocument`, options).toPromise();
  }

  deleteDocumentOfArchive(
    params: HttpParams | { idDocumentoArchivo: string },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}}
    return this.http.get(`${this.baseUrl}deleteDocumentOfArchive`, options).toPromise();
  }

  restoreFilesOfDocument(
    body: { idDocumentoArchivo: number },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = { headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}restoreFilesOfDocument`, body , options).toPromise();
  }

  iniciarCargaSiged(
    body: {
      idTipoDocumento: number,
      idArea: number,
      fechaInicio: string,
      fechaFin: string,
      idDocumentoArchivo: number
    },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = { headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}iniciarCargaSiged`, body , options).toPromise();
  }

  iniciarCargaSistram(
    body: {
      idTipoDocumento: number,
      idArea: number,
      fechaInicio: string,
      fechaFin: string,
      idDocumentoArchivo: number
    },
    headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = { headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}iniciarCargaSistram`, body , options).toPromise();
  }

  getDocumentalArchive(
    body: { idArchivoDocumental: any },
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}detalleArchivoDocumental`, body, options).toPromise();
  }

  cancelDocumentalArchive(
    body: { idArchivoDocumental: any },
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}anularArchivoDocumental`, body, options).toPromise();
  }

  firmarActa(
    body: { idArchivoDocumental: any, uuid: string, idPersona: any },
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}firmarActa`, body, options).toPromise();
  }

  firmarActaJefe(
    body: { idArchivoDocumental: any, uuid: string, idPersona: any },
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}firmarActaJefe`, body, options).toPromise();
  }

  solicitarFirma(
    body: { idArchivoDocumental: any, observacion: string, idPersonaEspecialista: any },
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}solicitarFirma`, body, options).toPromise();
  }

  aprobarArchivo(
    body: { idArchivoDocumental: any, uuid: string, idPersonaEspecialista: any },
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}aprobarArchivo`, body, options).toPromise();
  }

  observarArchivo(
    body: { idArchivoDocumental: any, observacion: string, idPersonaEspecialista: any },
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}observarArchivo`, body, options).toPromise();
  }

  eliminarArchivo(
    body: { idArchivoDocumental: any, observacion: string, idPersonaEspecialista: any },
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}eliminarArchivo`, body, options).toPromise();
  }

  terminarArchivo(
    body: { idArchivoDocumental: any, observacion: string, uuid: string, idPersonaEspecialista: any },
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}terminarArchivo`, body, options).toPromise();
  }

  subsanarArchivo(
    body: {
      idArchivoDocumental: any
      idTipoArchivo: any
      idPersona: any
      idPersonaEspecialista: any
      esSerieCerrada: number
      idSerieDocumental: any
      nombreSerieDocumental: string
      codigoSerieDocumental: string
      documentos: any[]
    },
    headers?
  ) {
    const obj = body
    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}subsanarArchivo`, obj, options).toPromise();
  }


  listaAcciones(
    headers?
  ) {

    const options = {headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}listaAcciones`, {}, options).toPromise();
  }

  listFilesByDocument(
    params: {id: string, page: string, size: string},
    headers?: HttpHeaders
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}};
    return this.http.get(`${this.baseUrl}listFilesByDocument`, options).toPromise();
  }

  listarArchivosSiged(
    body: {page: number, size: number, idTipoDocumento: number,
      idArea: number, fechaInicio: string, fechaFin: string, idDocumentoArchivo: number},
    headers?: HttpHeaders
  ) {
    const options = { headers: {...this.defaultHeaders, ...headers}};
    return this.http.post(`${this.baseUrl}listaArchivosSiged`, body, options).toPromise();
  }

  listarArchivosSistram(
    body: {pagina: number, tamanio: number, tipoDocumento: number,
      area: number, fechaInicio: string, fechaFin: string},
    headers?: HttpHeaders
  ) {
    const options = { headers: {...this.defaultHeaders, ...headers}};
    return this.http.post(`${this.baseUrl}listaArchivosSistram`, body, options).toPromise();
  }

  downloadReporteTransferencias(param: any): void {
    this.downloadReporte('reporte/transferenciaArchivo', param);
  }

  downloadReporteTransferenciasEliminadas(param: any): void {
    this.downloadReporte('reporte/eliminidaoArchivo', param);
  }

  // downloadActaTransferencias(param: any): void {
  //   this.downloadReporte('reporte/actaTransferencia', param);
  // }

  downloadActaTransferencias(param: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.downloadReporte('reporte/actaTransferencia', param)
        .subscribe({
          next: () => {
            console.log('Descarga completada');
            resolve(true);
          },
          error: (error) => {
            console.error('Error en la descarga', error);
            reject(false);
          }
        });
    });
  }
  

  downloadReporte(path: string, param: any): Observable<any> {
    const params = new URLSearchParams();
    for (const key in param) {
      let objInput = param[key];
      if (param[key]) {
        params.append(key, objInput);
      }
    }

    return this.http.get(this.baseUrl2 + `${path}?` + params.toString(), { responseType: 'blob' });
  }

  saveProcesoCarga(){

  }
}
